import { ClientParams } from '../localeParams'

export const clientJA: ClientParams = [
  ') バリデータ-の状態を確認',
  ') バリデーターの鍵をダウンロード',
  ') バリデーターの鍵を作成',
  ') バリデーターの鍵をアップロード',
  ') 鍵/ネットワークを設定する',
  ') アンインストール',
  ') 終了',
]

export const clientSubJA = [
  [],
  [
    ') バリデータ-の状態を確認',
    ') バリデーターのログを表示',
    ') バリデータ-を開始',
    ') バリデータ-を停止',
    ') バリデータ-を再起動 (fetch snapshot なし)',
    ') バリデータ-を再起動 (fetch snapshot あり)',
    ') メインメニューに戻る',
  ],
  [
    ') バリデータ-の設定を見る',
    ') バリデータ-の鍵の パス/アドレス/残高 を見る',
    ') 現在の エポック/スロット を見る',
    ') バリデーターの Catchup 情報を見る',
    ') バリデーターのモニター情報を見る',
    ') メインメニューに戻る',
  ],
  [
    ') バリデーターの鍵をバックアップ',
    ') バリデーターの鍵をリストア',
    ') メインメニューに戻る',
  ],
  [],
  [],
  [],
]
